import { BoxProps as BoxPropsMui } from '@mui/material';
import { LayoutProps } from '../../utils/layout-spacing-props';
import { StyledBox } from './Box.styles';

export interface BoxProps
  extends Pick<
      BoxPropsMui,
      | 'children'
      | 'onMouseEnter'
      | 'onMouseLeave'
      | 'onClick'
      | 'onDragOver'
      | 'onDragLeave'
      | 'onDrop'
    >,
    LayoutProps {}

export function Box(props: BoxProps) {
  return <StyledBox {...props} />;
}
